// src/router/authGuard.js

export default function authGuard(to, from, next) {
    const isAuthenticated = !!localStorage.getItem('access_token');
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!isAuthenticated) {
            next({ name: 'Login' });
        } else {
            next();
        }
    }
    else if (to.matched.some(record => record.meta.guest)) {
        if (isAuthenticated) {
            next({ name: 'Dashboard' });
        } else {
            next();
        }
    }
    else {
        next();
    }
}